<template>
    <div ref="plusbox" class="relative flex flex-row justify-start">
        <div ref="popup" v-show="showBox"
             class="bg-white pin-r absolute z-10 mt-2 -mr-44 items-center w-64 border-grey-lighter rounded-lg border-2">
            <div  @click="selectOptionClick(option.type, option.id)"
                  v-for="option in advertisement"
                  class="w-full pt-1 pb-1 flex flex-row justify-between px-6 selectedLabel cursor-pointer">
                <div class="flex flex-col">
                    {{advertismentNamePopup(option)}}
                </div>
                <img src="@/assets/SVG/tick.svg" alt="">
            </div>
        </div>
        <div @click.stop="onPlusboxClick"
              class="flex  outline-none flex-col bg-white rounded border-grey-lighter">
            <div v-if="slide.advertisement_id !== null" class="flex">
                <div class="md:w-40 px-2 h-10 flex justify-center items-center text-xs font-bold text-menuOrder-dark-blue bg-white border border-additional-text rounded cursor-pointer">
                    <p class="mx-2 whitespace-no-wrap">{{advertismentNameBox}} </p>
                    <img class="w-4 h-4 md:hidden mr-2" @click="$emit('removed', place, slide.id)" src="@/assets/SVG/cross-partners.svg" alt="">
                </div>
                <div class="hidden md:flex items-center" id="trashBin">
                    <trash-bin class="ml-12" @delete_element="$emit('removed', place, slide.id)"></trash-bin>
                </div>
            </div>
            <div v-else class="w-18 flex justify-center outline-none items-center border border-additional-text text-black pt-3 pb-3 rounded cursor-pointer ">
                <font-awesome-icon class="text-brand-light text-xs" :icon="['fas', 'plus']"></font-awesome-icon>
            </div>
        </div>
    </div>
</template>

<script>
import client from '@/clients/partners';
import Form from 'form-backend-validation';
import Popper from 'popper.js';
import TrashBin from './events/order/steps/layout/trash-bin';

export default {
  name: 'plus-box',
  components: { TrashBin },
  props: ['place', 'advertisement', 'slide'],
  data() {
    return {
      showBox: null,
      hideSelectboxHandler: null,
      form: new Form({
        advertisement: [],
      }, { http: client }),
      typeAdvertisement: {
        'mozgo-party': 'Mozgoparty',
        instagram: 'Инстаграм-конкурс',
        vk: 'Vk-конкурс',
        corporate: 'Корпоративные игры',
        partners: 'Покупка франшизы',
        'next-game': 'Следующая игра',
        free: 'Свободная афиша',
      },
    };
  },
  created() {
    this.hideSelectboxHandler = () => {
      this.showBox = false;
    };
  },
  watch: {
    showBox() {
      if (this.showBox) {
        this.setupPopper();
        document.addEventListener('click', this.hideSelectboxHandler);
      } else {
        document.removeEventListener('click', this.hideSelectboxHandler);
      }
    },
  },
  beforeDestroy() {
    if (this.popper) {
      this.popper.destroy();
    }
  },

  computed: {
    advertismentNameBox() {
      const adv = this.advertisement.find(item => item.id === this.slide.advertisement_id);
      return this.showNumber(adv.type) ? `${this.typeAdvertisement[this.slide.name]}(${adv.num})` : this.typeAdvertisement[this.slide.name];
    },
  },
  methods: {

    advertismentNamePopup(advertisment) {
      return this.showNumber(advertisment.type) ? `${this.typeAdvertisement[advertisment.type]}(${advertisment.num})` : this.typeAdvertisement[advertisment.type];
    },

    showNumber(adType) {
      return this.advertisement.filter(item => item.type === adType).length > 1;
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.plusbox, this.$refs.popup, {
          placement: 'bottom',
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
    selectOptionClick(option, id) {
      this.$emit('add', this.place, this.slide.id, option, id);
      this.showBox = false;
    },

    onPlusboxClick(event) {
      if (event.target.tagName === 'IMG' || event.target.id === 'trashBin' || event.target.id === 'trashButton') return;
      this.showBox = !this.showBox;
    },
  },
};
</script>

<style scoped lang="less">
    .selectedLabel {
        color: #333333;
    &:hover {
         color: white;
         background-color: #BD006C;
     }
    }
</style>
